import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  grid-gap: 15px;
  margin-bottom: 50px;
  width: 100%;

  @media (max-width: 768px) {
    padding: 15px;
  }

  @media (max-width: 480px) {
    padding: 10px;
  }
`;

export const FormGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-content: space-between;
  width: 100%;
  grid-gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const InputContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin: 30px 0;

  .flex {
    width: 100%;
    display: flex;
    gap: 15px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  justify-content: space-between;
  /* margin-top: 30px; */
  align-self: center;

  @media (max-width: 768px) {
    width: 100%;
    /* align-items: center; */
  }
`;

export const ButtonContainer2 = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  justify-content: space-between;
  margin: 30px 0;
  align-self: center;

  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    align-items: flex-start;
    gap: 10px;
  }
`;

export const DetailsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 818px;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    align-items: flex-start;
  }
`;

export const DetailCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 384px;
  height: 88px;
  padding: 7px 14px 7px 14px;
  /* gap: 12px; */
  border-radius: 12px;
  border: 1px solid #ffffff14;
  background: #ffffff0a;

  @media (max-width: 768px) {
    width: 100%;
    align-items: flex-start;
  }
`;

export const Prop = styled.p`
  font-size: 14px;
  font-weight: 500;
  line-height: 16.8px;
  color: #6c82a4;
`;

export const Value = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 19.2px;
  color: ${({ theme }) => theme.black};
`;

export const TextLabel = styled.p`
  font-size: 24px;
  font-weight: 600;
  line-height: 28.8px;
  text-align: left;
  color: ${({ theme }) => theme.black};

  @media (max-width: 768px) {
    text-align: center;
  }
`;

export const Description = styled.p`
  width: 100%;
  padding: 30px;
  border-bottom: 1px solid #ffffff14;

  @media (max-width: 768px) {
    padding: 10px;
  }
`;

export const OutlinedButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 386px;
  height: 56px;
  border-radius: 51px;
  border: 1px solid #ffffff14;
  background: #ffffff0a;

  &:hover {
    background-color: ${({ theme }) => theme.greenDark};
  }

  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
  }
`;

export const FilledButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 386px;
  height: 56px;
  border-radius: 51px;
  border: 1px solid #ffffff14;
  background-color: ${({ theme }) => theme.greenLight};
  transition: background-color 0.3s, box-shadow 0.3s;
  border: 1px solid #38d8ab;

  &:hover {
    background-color: ${({ theme }) => theme.greenDark};
  }

  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
  }
`;

export const FilledButton2 = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 56px;
  border-radius: 51px;
  border: 1px solid #ffffff14;
  background-color: ${({ theme }) => theme.greenLight};
  transition: background-color 0.3s, box-shadow 0.3s;
  border: 1px solid #38d8ab;
  color: ${({ theme }) => theme.black};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.greenDark};
    color: ${({ theme }) => theme.black};
  }

  &:disabled {
    opacity: 0.25;
  }
`;

export const TransactionHashSection = styled.div`
  margin-top: 100px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 396px;
  padding: 10px;
  gap: 10px;
  position: relative;

  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    align-items: flex-start;
  }
`;

export const TransactionHashContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 48px;
  padding: 10px;
  background: #ffffff0a;
  font-size: 16px;
  font-weight: 500;
  line-height: 19.2px;
  margin-bottom: 30px;
`;

export const RewardDetailsSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 700px;
  gap: 2rem;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 0 1rem;
  }
`;

export const RewardDetails = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  width: 100%;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;


export const RewardDetail = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  margin-bottom: 0.5rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

  .prop {
    font-size: clamp(0.95rem, 2.5vw, 1.1rem);
    font-weight: 500;
    color: ${({ theme }) => theme.textSecondary || "#6c82a4"};
    white-space: nowrap;
  }

  .value {
    font-size: clamp(0.7rem, 3vw, 1.0rem);
    font-weight: 600;
    color: ${({ theme }) => theme.textPrimary || theme.black};
    text-align: right;
    overflow-wrap: anywhere;
  }

  @media (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.3rem;

    .value {
      text-align: left;
    }
  }
`;


export const UploadCSVButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  text-align: center;
  width: auto;
  height: 43px;
  padding: 10px;
  gap: 10px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.greenLight};
  /* background: ${({ theme }) => theme.greenLight}; */
  color: ${({ theme }) => theme.greenLight};

  svg {
    font-size: 24px;
    color: ${({ theme }) => theme.greenLight};
  }
`;

export const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 30px 0;
  gap: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    align-items: flex-start;
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  .child {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: 1px solid #ffffff1f;
    border-radius: 50%;
    cursor: pointer;

    &:hover {
      color: ${({ theme }) => theme.greenLight};
    }
  }

  .active-child {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: 1px solid ${({ theme }) => theme.greenLight};
    background-color: ${({ theme }) => theme.greenLight};
    border-radius: 50%;
    cursor: pointer;
  }
  /* 
  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    align-items: flex-start;
  } */
`;

export const DetailsSummaryContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-end;
  flex-direction: column;
  @media (max-width: 768px) {
    width: 100%;
    align-items: flex-start;
  }
`;

export const DetailsSummary = styled.div`
  width: 269.65px;
  border-bottom: 1px solid #ffffff14;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 10px;

  .prop {
    font-size: 16px;
    font-weight: 400;
    line-height: 34px;
    color: ${({ theme }) => theme.black};
  }

  .value {
    font-size: 18px;
    font-weight: 400;
    line-height: 34px;
    color: ${({ theme }) => theme.black};
  }
`;

export const ResponsiveFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    align-items: flex-start;
  }
`;

export const TokenBalanceContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 20%;
`;

export const TokenBalance = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 16.8px;
  text-align: right;

  span {
    font-size: 14px;
    font-weight: 500;
    line-height: 16.8px;
  }
`;

export const NativeTokenTogglerContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 20px;
  font-size: 16px;
  font-weight: 500;
  line-height: 19.2px;
  text-align: left;
`;
